import React from 'react'
import { connect } from 'react-redux'
import { clearAuth } from '../../redux/actions/authAction'
import { setSearchFormData } from '../../redux/actions/searchFormActions'
import Root from './Root'
import { clearAgentSelection } from '../../redux/actions/gsaAgentAction'

const RootContainer = ({
	isLoading,
	toastDetails,
	displayPopup,
	setSearchFormDataToState,
	clearAuthFromState,
	principal,
	clearGsaAgentDetails
}) => {
	return (
		<Root
			isLoading={isLoading}
			toastDetails={toastDetails}
			displayPopup={displayPopup}
			setSearchFormDataToState={setSearchFormDataToState}
			clearAuthFromState={clearAuthFromState}
			principal={principal}
			clearGsaAgentDetails={clearGsaAgentDetails}
		/>
	)
}

const mapStateToProps = ({ loader, toast, auth }) => ({
	principal: auth.principal,
	isLoading: loader.isLoading,
	toastDetails: toast.toastDetails,
})

const mapDispatchToProps = (dispatch) => ({
	setSearchFormDataToState: (searchFormData) => {
		dispatch(setSearchFormData(searchFormData))
	},
	clearAuthFromState: () => {
		dispatch(clearAuth())
	},
	clearGsaAgentDetails: () =>{
		dispatch(clearAgentSelection())
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(RootContainer)
